import { useContext, useEffect } from 'react';
import './App.css';
import { AuthContext } from './auth/AuthProvider';
import Spinner from './components/Spinner';
import sfAuth from './SFAuth';

function App() {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_APPLICATION_NAME!.toUpperCase()} Login`;
  }, []);
  
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (!authContext.sessionChecked || !authContext.loggedIn) {
      return;
    }

    (async () => {
      const token = await sfAuth.fetchToken();
      sendDataToNative(token);
    })();
  }, [authContext.loggedIn, authContext.sessionChecked]);

  function sendDataToNative(data: any) {
    // @ts-ignore
    if (typeof window.chrome.webview != 'undefined') {
      // @ts-ignore
      window.chrome.webview.hostObjects.native.login(data).then(
        () => {
          // alert(`Token ${data} sent to desktop.`);
        },
        () => {
          // alert("Promise was rejected, couldn't send data!");
        },
      );
    } else {
      alert("You're attempting to login without a redirect or from outside a Silver Fern Native app!");
    }
  }

  return <Spinner active />;
}

export default App;
